import {combineReducers} from 'redux';

import {
  ALERT_CLEAR,
  ALERT_ERROR,
  ALERT_WARNING,
  ALERT_NOTIFICATION
} from '../actions/alertAction';

export default (
  initialState = {
    error: '',
    warning: '',
    notification: '',
    showReload: false,
    sticky: false,
  }, action) => {
  switch (action.type) {
    case ALERT_CLEAR: {
      return {
        ...initialState,
        error: '',
        warning: '',
        notification: '',
        sticky: false,
        showReload: false
      };
    }
    case ALERT_ERROR: {
      return {
        ...initialState,
        error: action.payload,
        sticky: action.sticky,
        showReload: action.showReload
      };
    }
    case ALERT_WARNING: {
      return {
        ...initialState,
        warning: action.payload,
        sticky: action.sticky,
        showReload: action.showReload
      };
    }
    case ALERT_NOTIFICATION: {
      return {
        ...initialState,
        notification: action.payload,
        sticky: action.sticky,
        showReload: action.showReload
      };
    }

    default:
    return initialState;
  }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/alertReducer.jsx